import React from "react";
import { FormControl } from "react-bootstrap";

export default class ReportsParameterSortBy extends React.Component {
    constructor(props) {
        super(props);
    }    

    handleChange() {
        if (this.props.onChange)
            this.props.onChange(this.inputEl.value);
    }

    render() {
        return (      
            <div className="ap-report-control-dropdown">    
                <FormControl
                    componentClass="select"
                    placeholder="select"
                    onChange={this.handleChange.bind(this)}
                    inputRef={el => this.inputEl = el}>
                    <option value="approver" selected="true">Approver</option>
                    <option value="people">People</option>
                </FormControl>
            </div>
        );
    }
}